import { render, staticRenderFns } from "./component-a12b3dfe.vue?vue&type=template&id=70f70094&scoped=true&"
import script from "./component-a12b3dfe.vue?vue&type=script&lang=js&"
export * from "./component-a12b3dfe.vue?vue&type=script&lang=js&"
import style0 from "./component-a12b3dfe.vue?vue&type=style&index=0&id=70f70094&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f70094",
  null
  
)

export default component.exports